export const rolesList = [
   { id: 1, label: "Admin", value: "admin" },
   { id: 2, label: "User", value: "user" }
];
